import { CommonGet, CommonPost } from "../../../../utils/CommonFetch";
import moment from 'moment';

export default {

    getAlGroupsForDropdown,
    getEstatesByGroupID,
    getDivisionByEstateID,
    GetAllOperationEntityByGroupID,
    GetFieldsByCollectionPoint,
    GetBlocksByFieldID,
    getIntegrationLogReportDetails,
    getIntegrationLogRSMReportDetails
};


async function getAlGroupsForDropdown() {
    var groupArray = [];
    const response = await CommonGet('/api/Group/GetAllGroups', null)
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function GetAllOperationEntityByGroupID(groupID) {
    const dataArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllOperationEntityByGroupID', 'groupID=' + groupID);
    for (let item of Object.entries(response.data)) {
        dataArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
    }
    return dataArray;
}

async function getEstatesByGroupID(id) {
    var estateArray = [];
    const response = await CommonGet('/api/OperationEntity/GetAllEstatesByGroupID', 'groupID=' + id);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            estateArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"]
        }
    }
    return estateArray;
}


async function getDivisionByEstateID(operationEntityID) {
    const response = await CommonGet('/api/CollectionPoint/GetAllCollectionPoint', null);
    let array = []
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true && item[1]["operationEntityID"] == operationEntityID) {
            array[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return array;
}

async function GetFieldsByCollectionPoint(id) {
    var response = await CommonGet('/api/Field/GetFieldsByCollectionPointID', 'id=' + id);
    let fieldArray = [];
    for (let item of Object.entries(response.data)) {
        fieldArray[item[1]["fieldID"]] = item[1]["fieldName"];
    }
    return fieldArray;
}

async function GetBlocksByFieldID(id) {
    var response = await CommonGet('/api/Block/GetBlocksByFieldID', 'id=' + id);
    let blockArray = [];
    for (let item of Object.entries(response.data)) {
        blockArray[item[1]["blockID"]] = item[1]["blockName"];
    }
    return blockArray;
}


async function getIntegrationLogReportDetails(data) {
    var model = {
        groupID: parseInt(data.groupID),
        estateID: parseInt(data.estateID),
        divisionID: parseInt(data.divisionID),
        fieldID: parseInt(data.fieldID),
        attendanceTypeID: parseInt(data.attendanceTypeID),
        blockID: parseInt(data.blockID),
        date: data.date,
    };
    const response = await CommonPost('/api/IntegrationLogReport/GetIntegrationLogReportDetails', null, model);
    console.log('response', response)

    return response.data;
}

async function getIntegrationLogRSMReportDetails(data) {
    var model = {
        groupID: parseInt(data.groupID),
        estateID: parseInt(data.estateID),
        divisionID: parseInt(data.divisionID),
        fieldID: parseInt(data.fieldID),
        attendanceTypeID: parseInt(data.attendanceTypeID),
        blockID: parseInt(data.blockID),
        date: data.date,
    };
    const response = await CommonPost('/api/IntegrationLogReport/GetIntegrationLogRSMReportDetails', null, model);
    return response.data;
}
